<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 30 30"
    :color="color"
    title="Logo TikTok"
  >
    <!-- eslint-disable max-len -->
    <path
      d="M13.6083 0.0348323C5.74096 0.794064 -0.244671 7.55745 0.00769369 15.4027C0.0810384 17.6845 0.574854 19.66 1.57551 21.6754C3.03742 24.6199 5.37283 26.9545 8.32381 28.4216C13.1076 30.7999 18.7612 30.4729 23.2231 27.5598C24.9677 26.4208 26.6211 24.7322 27.7499 22.9367C28.1789 22.2543 28.8266 20.9277 29.1208 20.129C29.4172 19.3241 29.7629 17.9273 29.8911 17.016C30.021 16.0929 30.0385 13.9574 29.9229 13.1442C29.5765 10.708 28.8038 8.634 27.521 6.69703C26.9754 5.87326 26.4306 5.20866 25.6715 4.44104C23.3313 2.07453 20.4202 0.606808 17.0915 0.115143C16.3737 0.00913736 14.3565 -0.0373833 13.6083 0.0348323ZM18.218 7.66498C18.5012 8.96557 19.1581 9.88812 20.131 10.3519C20.6305 10.5899 21.2464 10.7683 21.5693 10.7683H21.7562V12.0589V13.3495L21.4188 13.349C20.6052 13.348 19.7624 13.1113 18.7912 12.6112C18.452 12.4365 18.161 12.2935 18.1446 12.2935C18.1282 12.2935 18.1309 12.8545 18.1507 13.5401C18.1966 15.1302 18.0945 18.1121 17.9766 18.6293C17.6856 19.9046 17.0203 20.9972 16.0786 21.7465C14.2024 23.2391 11.9027 23.2757 10.0928 21.8416C9.37029 21.2691 8.71395 20.2195 8.43254 19.1866C8.273 18.601 8.21233 17.3325 8.31794 16.7923C8.65116 15.0887 10.0271 13.5923 11.7486 13.0613C12.2161 12.9171 13.1024 12.7634 13.4683 12.7631L13.7176 12.7628V14.0764V15.3901L13.2922 15.4926C11.8664 15.8363 11.2273 16.2798 10.8975 17.1541C10.7172 17.6321 10.7545 18.353 10.9829 18.8052C11.4688 19.7676 12.2609 20.2465 13.2953 20.2033C14.3585 20.1589 15.0004 19.5992 15.3695 18.3944L15.5043 17.9546L15.5225 12.5135L15.5406 7.07242L16.8148 7.07265L18.089 7.07283L18.218 7.66498Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
